import { compose, lifecycle, withHandlers } from 'recompose';
import withPopover from 'shared/hocs/withPopover';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { currentModalSelector } from 'modules/messageSystem/selectors/currentModal';

import Footer from './Footer';

export default compose(
  connect(
    state => ({
      modalOpened: currentModalSelector(state),
      isAuthorized: !!state.session.sessionInfo.sessionId,
    }),
  ),
  withPopover(false),
  withRouter,
  injectIntl,

  withHandlers({
    escapeHandler: ({ modalOpened, closePopover, anchorEl }) => e => {
      if (!!anchorEl && !modalOpened && (e.key === 'Escape' || e.keyCode === 27)) closePopover();
    },
  }),

  lifecycle({
    componentDidMount() {
      document.addEventListener('keydown', this.props.escapeHandler);
    },

    componentWillUnmount() {
      document.removeEventListener('keydown', this.props.escapeHandler);
    },
  }),
)(Footer);
